var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#5E5E5E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67582 13.25C1.41943 13.25 1.20104 13.1598 1.02062 12.9794C0.840207 12.799 0.75 12.5806 0.75 12.3242C0.75 12.0718 0.841195 11.8544 1.02358 11.672C1.20598 11.4896 1.4234 11.3984 1.67582 11.3984H12.1686C12.425 11.3984 12.6434 11.4886 12.8238 11.669C13.0043 11.8494 13.0945 12.0678 13.0945 12.3242C13.0945 12.5766 13.0033 12.794 12.8209 12.9764C12.6385 13.1588 12.4211 13.25 12.1686 13.25H1.67582ZM2.85095 9.85529C2.6919 9.85529 2.55916 9.80207 2.45273 9.69564C2.34629 9.58922 2.29307 9.45648 2.29307 9.29743V8.2007C2.29307 8.12631 2.30653 8.05549 2.33344 7.98822C2.36034 7.92096 2.40268 7.85845 2.46045 7.80069L7.80773 2.46528L9.6831 4.34065L4.34769 9.68793C4.28992 9.7457 4.22741 9.78804 4.16014 9.81494C4.09289 9.84184 4.02206 9.85529 3.94768 9.85529H2.85095ZM10.3062 3.69732L8.43088 1.83381L9.34008 0.924612C9.45324 0.805118 9.59527 0.746954 9.76619 0.750123C9.93712 0.753291 10.0792 0.811455 10.1923 0.924612L11.2036 1.93587C11.3167 2.04903 11.3753 2.18949 11.3793 2.35725C11.3832 2.52501 11.3286 2.66863 11.2155 2.78812L10.3062 3.69732Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b4daab09e4bed461b7267c276eff8cb9.svg";
export { ForwardRef as ReactComponent };